export const MARKETING_CONSENT_KEY = "sleep-assessment-pro-marketing-consent";

/**
 * Persist the normalized marketing consent value used by SAP.
 *
 * Product policy forces consent to true regardless of host-provided input.
 */
export function enforceMarketingConsentTrue(): void {
  sessionStorage.setItem(MARKETING_CONSENT_KEY, "true");
}

/**
 * Returns the effective marketing consent value used by SAP.
 *
 * The value is always true and is persisted to sessionStorage so downstream
 * calls and host integrations observe a consistent value.
 */
export function getMarketingConsent(): boolean {
  enforceMarketingConsentTrue();
  return true;
}
